import React from "react";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useState } from "react";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
const ReedemType = ({ status }) => {

 const clientData = useSelector(
    (state) => state.clientConfigurationReducer?.clientConfigurationData[0]
  );

  const [images, setImages] = useState({
    online: '',
    offline: '',
    both: '',
  });


  useEffect(() => {
    
    if (clientData) {
      setImages({
        online:  clientData?.redeemableOnlineImg   ?  `${process.env.REACT_APP_CLIENT_URL}${clientData.redeemableOnlineImg}` : '',
        offline: clientData?.redeemableOfflineImg ? `${process.env.REACT_APP_CLIENT_URL}${clientData.redeemableOfflineImg}` : '',
        both: clientData?.redeemableOnlineOfflineImg ? `${process.env.REACT_APP_CLIENT_URL}${clientData.redeemableOnlineOfflineImg}` : '',
      });
    }
  }, [clientData]);

   const translation = getTranslationData();
  const iconAndTextMapper = [
    {
      status: "",
      icon: (images.online? <img src={images.online} width="16" height="16" /> : null),
      textKey: translation?.redeemableOnline,
      className: "reeedem_online",
    },
    {
      status: "Redeemable Online",
      icon: (images.online? <img src={images.online} width="16 !important" height="16 !important" /> : null),
      textKey:  translation?.redeemableOnline || "Redeemable Online",
      className: "reeedem_online",
    },
    {
      status: "Redeemable Offline",
      icon: (images.offline? <img src={images.offline} width="16 !important" height="16 !important" /> : null),
      textKey: translation?.redeemableOffline || "Redeemable Offline",
      className: "reeedem_offline",
    },
    {
      status: "Redeemable Online & Offline",
      icon: (images.both? <img src={images.both} width="16 !important" height="16 !important" /> : null),
      textKey: translation?.redeemableBoth || "Redeemable Online/Offline",
      className: "reeedem_both",
    },
  ];

  return (
    <>
      <span
        className={`reeedem mt-2 ${
          iconAndTextMapper.find((item) => item.status === status)?.className
        }`}
      >
        {iconAndTextMapper.find((item) => item.status === status)?.icon}
        <span className="reedem_text">
          {iconAndTextMapper.find((item) => item.status === status)?.textKey}
        </span>
      </span>
    </>
  );
};

export default ReedemType;
